// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__17RCN","title":"FrontImage_title__3RtWv"};